<lib-modal-layout [title]="'Endorsement Request'" [subtitle]="data.businessName + ' - ' + data.policyNumber">
    <h4 class="my-4 text-center">Request Submitted</h4>
    <p class="text-center my-4">
        Your endorsement request has been submitted. A program underwriter will review your request and be in touch
        within 1-2 business days.
    </p>
    <div class="text-center" btnPrimary>
        <lib-button [cssType]="'btn-primary'" [text]="'Close'" [type]="'button'"
            (click)="closeModal()"></lib-button>
    </div>
</lib-modal-layout>